import { render, staticRenderFns } from "./VoicePrompt.vue?vue&type=template&id=14a4fbda&"
import script from "./VoicePrompt.vue?vue&type=script&lang=ts&"
export * from "./VoicePrompt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports